import {Injectable} from 'ng-metadata/core';
import {ChangeLangService} from "../../../infra/lang/changeLang.service";

@Injectable()
export class SearchResultToolBarService {
    private sliderButtons = ['dismissAllRecordSelect', 'exportAllResultsBtn', 'chooseTopMax'];
    private toolbarButtons = ['searchResultPageRangeSelect', 'personalizationBtn', 'saveQueryBtn'];

    constructor(private changeLangService: ChangeLangService) {
    }

    public handleToolBarOnClose(){

        // 1. Hide Slider
        let elem = document.querySelector("prm-search-result-tool-bar .floated-max-results-message") as HTMLElement;
        if (elem) {
            let dir = (this.changeLangService.direction) === 'ltr' ? 'left' : 'right';
            angular.element(elem).css(dir, '-100%');
        }

        // 2. Handle focus
        this.toolbarButtons.forEach((id) => {
            const element = document.getElementById(id);
            if (element) {
                element.setAttribute('tabindex', '0');
            }
        });


        this.sliderButtons.forEach((id) => {
            const element = document.getElementById(id);
            if (element) {
                element.setAttribute('tabindex', '-1');
            }
        });

        // 3. Return focus to the select all checkbox
        let selectElement = document.getElementById('searchResultTolBarSelectAllCheckbox');
        if (selectElement) {
            selectElement.focus();
        }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultToolBar/searchResultToolBar.service.ts